// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}


@media (max-width: 690px) {
  html {
    font-size: 80%;
    font-family: "Montserrat", sans-serif;
  }
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);

  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 7.5px;
  height: 7.5px !important;
  border-radius: 13px;

  /* background-color: #F5F5F5; */
}

::-webkit-scrollbar-thumb {
  border-radius: 30px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(62, 172, 214, 0.5);
}

.otp-field {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.otp-field__input_sm {
  width: 36px;
  height: 36px;
  margin: 6px;
  border: 2px solid #ec6c83;
  border-radius: 5px;
  color: #ec6c83;
  box-sizing: border-box;
  font-size: 25px;
  font-weight: 500;
  /* Chrome, Safari, Edge, Opera */
  text-align: center;
}

.otp-field__input_sm::-webkit-outer-spin-button,
.otp-field__input_sm::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
  /* Firefox */
}

.otp-field__input_sm[type="number"] {
  -moz-appearance: textfield;
}

.otp-field__input_sm:focus {
  border-color: #3eacd6;
  outline: none;
}

.otp-field__input_sm:disabled {
  background-color: #050101;
  color: #aaa;
}

.otp-field--has-errored .otp-field__input_sm {
  border-color: #ff0101 !important;
  color: #222;
}

.otp-field__input {
  width: 50px;
  height: 50px;
  margin: 10px;
  border: 2px solid #ec6c83;
  border-radius: 5px;
  color: #ec6c83;
  box-sizing: border-box;
  font-size: 25px;
  font-weight: 500;
  /* Chrome, Safari, Edge, Opera */
  text-align: center;
}

.otp-field__input::-webkit-outer-spin-button,
.otp-field__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
  /* Firefox */
}

.otp-field__input[type="number"] {
  -moz-appearance: textfield;
}

.otp-field__input:focus {
  border-color: #3eacd6;
  outline: none;
}

.otp-field__input:disabled {
  background-color: #050101;
  color: #aaa;
}

.otp-field--has-errored .otp-field__input {
  border-color: #ff0101 !important;
  color: #222;
}

.tableEmployees th {
  background-color: rgba(254, 245, 246, 1);
  /* height: 42px; */
  color: #ec6c83;
  font-family: Montserrat, sans-serif;
  font-weight: bold;
}

.row:hover .detail {
  display: none !important;
}

.row:hover .display {
  display: flex !important;
}
#textArea {
  font-family: Montserrat, sans-serif;
  font-size: 14px;
}
#textArea:focus {
  outline-color: #ec6c83;
}

#textArea::placeholder {
  font-family: Montserrat, sans-serif;
}

#textArea1:focus {
  outline-color: #ec6c83;
}

#textArea1 {
  font-family: Montserrat, sans-serif;
  font-size: 15px;
}
#textArea1::placeholder {
  font-family: Montserrat, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;;AAGA;EACE;IACE,cAAc;IACd,qCAAqC;EACvC;AACF;;AAEA;EACE,oDAAoD;;EAEpD,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;;EAEnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n\n@media (max-width: 690px) {\n  html {\n    font-size: 80%;\n    font-family: \"Montserrat\", sans-serif;\n  }\n}\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n\n  background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar {\n  width: 7.5px;\n  height: 7.5px !important;\n  border-radius: 13px;\n\n  /* background-color: #F5F5F5; */\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 30px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: rgba(62, 172, 214, 0.5);\n}\n\n.otp-field {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.otp-field__input_sm {\n  width: 36px;\n  height: 36px;\n  margin: 6px;\n  border: 2px solid #ec6c83;\n  border-radius: 5px;\n  color: #ec6c83;\n  box-sizing: border-box;\n  font-size: 25px;\n  font-weight: 500;\n  /* Chrome, Safari, Edge, Opera */\n  text-align: center;\n}\n\n.otp-field__input_sm::-webkit-outer-spin-button,\n.otp-field__input_sm::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n  /* Firefox */\n}\n\n.otp-field__input_sm[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.otp-field__input_sm:focus {\n  border-color: #3eacd6;\n  outline: none;\n}\n\n.otp-field__input_sm:disabled {\n  background-color: #050101;\n  color: #aaa;\n}\n\n.otp-field--has-errored .otp-field__input_sm {\n  border-color: #ff0101 !important;\n  color: #222;\n}\n\n.otp-field__input {\n  width: 50px;\n  height: 50px;\n  margin: 10px;\n  border: 2px solid #ec6c83;\n  border-radius: 5px;\n  color: #ec6c83;\n  box-sizing: border-box;\n  font-size: 25px;\n  font-weight: 500;\n  /* Chrome, Safari, Edge, Opera */\n  text-align: center;\n}\n\n.otp-field__input::-webkit-outer-spin-button,\n.otp-field__input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n  /* Firefox */\n}\n\n.otp-field__input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.otp-field__input:focus {\n  border-color: #3eacd6;\n  outline: none;\n}\n\n.otp-field__input:disabled {\n  background-color: #050101;\n  color: #aaa;\n}\n\n.otp-field--has-errored .otp-field__input {\n  border-color: #ff0101 !important;\n  color: #222;\n}\n\n.tableEmployees th {\n  background-color: rgba(254, 245, 246, 1);\n  /* height: 42px; */\n  color: #ec6c83;\n  font-family: Montserrat, sans-serif;\n  font-weight: bold;\n}\n\n.row:hover .detail {\n  display: none !important;\n}\n\n.row:hover .display {\n  display: flex !important;\n}\n#textArea {\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n}\n#textArea:focus {\n  outline-color: #ec6c83;\n}\n\n#textArea::placeholder {\n  font-family: Montserrat, sans-serif;\n}\n\n#textArea1:focus {\n  outline-color: #ec6c83;\n}\n\n#textArea1 {\n  font-family: Montserrat, sans-serif;\n  font-size: 15px;\n}\n#textArea1::placeholder {\n  font-family: Montserrat, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
